import { LayoutProps } from '@app/types'
import { Layout as AntLayout } from 'antd'

export const Layout: React.FC<LayoutProps> = (props) => <AntLayout {...props} />
